export const navbarData = {
  homeTitle: 'Thaís Baêta - Advocacia Trabalhista',
  blogTitle: 'Blog da Thaís Baêta - Advocacia Trabalhista',
}

export const defaultData = {
  date: new Date('2025-08-01'),
}

export const lp1Data = {
  title: 'Teve seus direitos trabalhistas violados?',
  subtitle: 'Seu direito trabalhista é a nossa especialidade!',
  description:
    'Seja representado por advogados especialistas na proteção do direito do trabalhador',
}

export const routesData = ['/', 'sitemap.xml', 'rss.xml', 'robots.txt']

export const seoData = {
  title: 'Thaís Baêta - Advocacia Trabalhista',
  ogTitle: `Blog da Thaís Baêta - Advocacia Trabalhista`,
  description: `Advocacia Trabalhista com foco em direitos dos trabalhadores, incluindo estabilidade gestacional, reversão de demissão por justa causa, rescisão indireta, pagamentos de adicinais de insalubridade e periculosidade e danos morais.`,
  twitterDescription: `Advocacia Trabalhista com foco em direitos dos trabalhadores, incluindo estabilidade gestacional, reversão de demissão por justa causa, rescisão indireta, pagamentos de adicinais de insalubridade e periculosidade e danos morais.`,
  image:
    'https://res.cloudinary.com/dmecmyphj/image/upload/v1673548905/nuxt-blog/cover_ntgs6u.webp',
  mySite: 'https://baeta.adv.br',
  twitterHandle: '@baetaadv',
  mailAddress: 'thaisbaeta@hotmail.com',
}

export const socialLinks = {
  githubLink: 'https://github.com/baetaadv',
  instagramLink: 'https://www.instagram.com/baetaadv',
  youtubeLink: '#',
  tiktokLink: '#',
}

export const siteMetaData = [
  {
    name: 'description',
    content: seoData.description,
  },
  // Teste em: https://developers.facebook.com/tools/debug/ ou https://socialsharepreview.com/
  { property: 'og:site_name', content: seoData.mySite },
  { property: 'og:type', content: 'website' },
  {
    property: 'og:url',
    content: seoData.mySite,
  },
  {
    property: 'og:title',
    content: seoData.ogTitle,
  },
  {
    property: 'og:description',
    content: seoData.description,
  },
  {
    property: 'og:image',
    content: seoData.image,
  },
  // Teste em: https://cards-dev.twitter.com/validator ou https://socialsharepreview.com/
  { name: 'twitter:site', content: seoData.twitterHandle },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:url',
    content: seoData.mySite,
  },
  {
    name: 'twitter:title',
    content: seoData.ogTitle,
  },
  {
    name: 'twitter:description',
    content: seoData.twitterDescription,
  },
  {
    name: 'twitter:image',
    content: seoData.image,
  },
]
